import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ProjectMockupJsonResponse {
  name: string;
  json: string;
}

export interface ProjectMockupImageUpload {
  /** Stable id stored on the background object so a fresh URL can be resolved on load. */
  id: string;
  /** Presigned S3 PUT URL for the image bytes. */
  uploadUrl: string;
  /** CloudFront URL used as the fabric image `src`. */
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class MockupEditorService {

  constructor(private http: HttpClient) {}

  getProjectFile(id: string): Observable<string> {
    return this.http.get<string>(`/projectFiles/file/v2/${id}`);
  }

  getProjectMockupJson(id: string): Observable<ProjectMockupJsonResponse> {
    return this.http.get<ProjectMockupJsonResponse>(`/mockups/v2/json/${id}`);
  }

  saveProjectMockup(projectId: string, payload: { name: string; json: string }): Observable<any> {
    return this.http.post<any>(`/mockups/v2/${projectId}`, payload);
  }

  updateProjectMockup(mockupId: string, payload: { name: string; json: string }): Observable<any> {
    return this.http.patch<any>(`/mockups/v2/${mockupId}`, payload);
  }

  deleteProjectMockup(mockupId: string): Observable<any> {
    return this.http.delete<any>(`/mockups/v2/${mockupId}`);
  }

  createProjectMockupImage(type: string): Observable<ProjectMockupImageUpload> {
    return this.http.post<ProjectMockupImageUpload>(`/mockups/v2/images`, { type });
  }

  getProjectMockupImageUrl(imageId: string): Observable<string> {
    return this.http.get<string>(`/mockups/v2/images/${imageId}`);
  }
}
